import { render } from "./DisplayAd.vue?vue&type=template&id=2fc1d476&scoped=true"
import script from "./DisplayAd.vue?vue&type=script&lang=js"
export * from "./DisplayAd.vue?vue&type=script&lang=js"

import "./DisplayAd.vue?vue&type=style&index=0&id=2fc1d476&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fc1d476"]])

export default __exports__